import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { BnEsDatePipe } from './bn-es-date.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [BnEsDatePipe],
  exports: [BnEsDatePipe],
  providers: [DatePipe],
})
export class BnEsDatePipeModule {}
